import { render, staticRenderFns } from "./input.vue?vue&type=template&id=cfe89bbc&"
import script from "./input.vue?vue&type=script&lang=js&"
export * from "./input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzIconX: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/icons/icon-x/index.js').default,RzPreloader: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/preloader/index.js').default,RzIconCross: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/icons/icon-cross/index.js').default,RzIconDropArrow: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/icons/icon-drop-arrow/index.js').default})
